import * as React from 'react';
import { WhitelabelConfig } from './types';

export const WhitelabelContext = React.createContext<WhitelabelConfig | null>(null);
WhitelabelContext.displayName = 'WhitelabelContext';
